import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center pt-12" };
const _hoisted_2 = { class: "flex flex-col w-full max-w-112" };
const _hoisted_3 = { class: "flex flex-col gap-8" };
const _hoisted_4 = { class: "flex flex-col" };
const _hoisted_5 = { class: "mb-2 font-bold text-gray-600 dark:text-primary-200" };
const _hoisted_6 = { class: "mb-1 text-xs text-primary-900 dark:text-primary-200" };
const _hoisted_7 = { class: "flex items-center" };
const _hoisted_8 = ["src"];
const _hoisted_9 = ["onSubmit"];
const _hoisted_10 = { class: "flex justify-end gap-8 mt-11" };
const _hoisted_11 = {
    key: 0,
    class: "flex flex-col gap-8"
};
const _hoisted_12 = { class: "flex flex-col mt-6" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("hr", { class: "mb-8 border-gray-200 dark:border-gray-700" }, null, -1);
const _hoisted_14 = { class: "flex flex-col" };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { class: "flex justify-between mb-4 align-baseline" };
const _hoisted_17 = { class: "flex space-x-3" };
const _hoisted_18 = { class: "text-lg" };
const _hoisted_19 = { class: "text-lg text-gray-600 dark:text-gray-200" };
const _hoisted_20 = { class: "flex justify-between gap-4 mb-10 align-baseline" };
const _hoisted_21 = { class: "text-gray-600 text-sm-but-a-bit-smaller dark:text-gray-200" };
const _hoisted_22 = { class: "mb-2 text-gray-600 text-sm-but-a-bit-smaller dark:text-gray-200" };
const _hoisted_23 = { class: "flex justify-between align-baseline" };
const _hoisted_24 = { class: "flex items-center px-1 text-xs font-semibold border border-wyeworks-black" };
const _hoisted_25 = { class: "mt-6 text-gray-600 text-sm-but-a-bit-smaller dark:text-gray-200" };
const _hoisted_26 = { class: "flex justify-between mt-2 align-baseline" };
const _hoisted_27 = { class: "font-bold text-sm-but-a-bit-smaller" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("hr", { class: "mt-10 border-gray-200 dark:border-gray-700" }, null, -1);
const _hoisted_29 = { class: "flex items-center" };
const _hoisted_30 = { class: "flex items-start mt-10" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.workspaces.edit')
};
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { TEAM_CONSTANTS, FEATURE_FLAGS } from '@/constants';
import { uploadImage } from '@/composables/images';
import NeedHelp from '@/components/NeedHelp.vue';
import SectionHeading from '@/components/base/headings/SectionHeading.vue';
import Supports from '@/components/image_uploads/Supports.vue';
import UploadImageButton from '@/components/image_uploads/UploadImageButton.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import ExternalLink from '../base/text/ExternalLink.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'Content',
    props: {
        workspace: null
    },
    setup(__props) {
        const props = __props;
        const name = ref(props.workspace.name);
        const uploadLoading = ref(false);
        const uploadError = ref(false);
        const router = useRouter();
        const store = useStore();
        const isPricingEnabled = FEATURE_FLAGS.PRICING_ENABLED;
        const isWorkspaceFree = computed(() => props.workspace.plan === 'free');
        const locale = computed(() => store.getters.locale);
        const dirty = computed(() => {
            return name.value !== props.workspace.name;
        });
        const canUpdateWorkspace = computed(() => {
            return dirty.value && nameError.value === '';
        });
        const formattedName = computed(() => name.value.trim());
        const nameError = computed(() => {
            if (formattedName.value.trim() === '') {
                return 'errors.name.empty';
            }
            else if (formattedName.value.length > TEAM_CONSTANTS.MAX_NAME_LENGTH) {
                return 'errors.name.too_long';
            }
            else {
                return '';
            }
        });
        const disabledReason = computed(() => {
            if (!dirty.value) {
                return 'errors.no_changes';
            }
            else {
                return nameError.value;
            }
        });
        const avatar = computed(() => {
            return props.workspace.avatar || require('@/assets/images/default-workspace-avatar.png');
        });
        const formattedNextBillingDate = computed(() => {
            const date = new Date(props.workspace.subscriptionPeriodEnd);
            const formatter = new Intl.DateTimeFormat(locale.value, {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            });
            return formatter.format(date);
        });
        const cancel = () => {
            if (!dirty.value) {
                router.push({ name: 'showWorkspace', params: { workspaceId: props.workspace.id } });
            }
            else {
                name.value = props.workspace.name;
            }
        };
        const save = () => {
            if (disabledReason.value === '') {
                store.dispatch('updateWorkspace', { name: name.value, workspaceId: props.workspace.id });
            }
        };
        const handleUpload = async (image) => {
            uploadLoading.value = true;
            uploadError.value = false;
            const result = await uploadImage(image, (file) => store.dispatch('updateWorkspaceAvatar', file));
            if (!result) {
                uploadError.value = true;
            }
            uploadLoading.value = false;
        };
        function managePaymentInfo() {
            store.dispatch('redirectToPaymentMethod');
        }
        function redirectToBillingDetails() {
            store.dispatch('redirectToBillingDetails');
        }
        return (_ctx, _cache) => {
            const _component_TextField = _resolveComponent("TextField");
            const _component_TextButton = _resolveComponent("TextButton");
            const _component_PillButton = _resolveComponent("PillButton");
            const _component_RouterLink = _resolveComponent("RouterLink");
            const _component_pill_button = _resolveComponent("pill-button");
            const _component_router_link = _resolveComponent("router-link");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SectionHeading, {
                    heading: _ctx.$t('settings')
                }, null, 8, ["heading"]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('general')), 1),
                            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('avatar')), 1),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("img", {
                                    class: _normalizeClass(["rounded-md w-15 h-15", uploadError.value ? 'border-2 border-red-500' : '']),
                                    src: _unref(avatar),
                                    alt: "Workspace avatar"
                                }, null, 10, _hoisted_8),
                                _createVNode(Supports, {
                                    class: "ml-4",
                                    error: uploadError.value
                                }, null, 8, ["error"]),
                                _createVNode(UploadImageButton, {
                                    class: "ml-auto",
                                    loading: uploadLoading.value,
                                    onUpload: handleUpload
                                }, null, 8, ["loading"])
                            ])
                        ]),
                        _createElementVNode("form", {
                            onSubmit: _withModifiers(save, ["prevent"])
                        }, [
                            _createVNode(_component_TextField, {
                                modelValue: name.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event)),
                                class: "w-full",
                                label: _ctx.$t('name'),
                                error: _ctx.$t(_unref(nameError))
                            }, null, 8, ["modelValue", "label", "error"])
                        ], 40, _hoisted_9)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_TextButton, { onClick: cancel }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                            ], undefined, true),
                            _: 1
                        }),
                        _withDirectives((_openBlock(), _createBlock(_component_PillButton, {
                            disabled: !_unref(canUpdateWorkspace),
                            onClick: save
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('save')), 1)
                            ], undefined, true),
                            _: 1
                        }, 8, ["disabled"])), [
                            [_directive_tooltip, !_unref(canUpdateWorkspace) && _ctx.$t(_unref(disabledReason))]
                        ])
                    ]),
                    (_unref(isPricingEnabled))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                _createElementVNode("h1", {
                                    class: _normalizeClass([{
                                            'mb-1': __props.workspace.canBeRefunded,
                                            'mb-10': !__props.workspace.canBeRefunded
                                        }, "font-bold text-gray-600 dark:text-gray-200"])
                                }, _toDisplayString(_ctx.$t('subscription_and_billing')), 3),
                                (__props.workspace.canBeRefunded)
                                    ? (_openBlock(), _createBlock(ExternalLink, {
                                        key: 0,
                                        class: "mb-6 text-sm-but-a-bit-smaller",
                                        href: "mailto:goodbye@retroally.com",
                                        text: _ctx.$t('money_guarantee')
                                    }, null, 8, ["text"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_14, [
                                    (!_unref(isWorkspaceFree))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _createVNode(SvgIcon, {
                                                            name: "credit-card",
                                                            class: "w-11 h-7"
                                                        })
                                                    ]),
                                                    _createElementVNode("div", _hoisted_19, _toDisplayString(`•••• •••• •••• ${__props.workspace.paymentMethodHint}`), 1)
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "block font-light text-center text-sm-but-a-bit-smaller text-blue-link dark:text-blue-light-link",
                                                    onClick: managePaymentInfo
                                                }, _toDisplayString(_ctx.$t('manage_payment_info')), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('next_billing_date', { date: _unref(formattedNextBillingDate) })), 1),
                                                _createElementVNode("button", {
                                                    class: "block font-light text-center whitespace-nowrap text-sm-but-a-bit-smaller text-blue-link dark:text-blue-light-link",
                                                    onClick: redirectToBillingDetails
                                                }, _toDisplayString(_ctx.$t('billing_details')), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.$t('plan_details')), 1),
                                    _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t(`plan_name_${__props.workspace.plan}`)), 1),
                                        _createVNode(_component_RouterLink, {
                                            to: { name: 'changeWorkspacePlan' },
                                            class: "block font-light text-center text-sm-but-a-bit-smaller text-blue-link dark:text-blue-light-link"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('change_plan')), 1)
                                            ], undefined, true),
                                            _: 1
                                        })
                                    ]),
                                    (!_unref(isWorkspaceFree) && !__props.workspace.isSuspended)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.$t('total_seats')), 1),
                                            _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("div", _hoisted_27, _toDisplayString(__props.workspace.seats), 1),
                                                _createVNode(_component_RouterLink, {
                                                    to: { name: 'editWorkspaceSeats' },
                                                    class: "block font-light text-center text-sm-but-a-bit-smaller text-blue-link dark:text-blue-light-link"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('manage_seats')), 1)
                                                    ], undefined, true),
                                                    _: 1
                                                })
                                            ])
                                        ], 64))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_router_link, { to: { name: 'deleteWorkspace' } }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_pill_button, { kind: "secondary" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('delete')), 1)
                                        ], undefined, true),
                                        _: 1
                                    })
                                ], undefined, true),
                                _: 1
                            })
                        ])
                    ])
                ]),
                _createVNode(NeedHelp, { class: "mt-11" })
            ]));
        };
    }
});
